import {Params} from '@feathersjs/feathers'

import {FinishGroup} from '../../types'

import * as feathersService from '../feathers'

export const RESOURCE = 'finishGroup'

export const get = async (params?: Params) => feathersService.find<FinishGroup>(RESOURCE, params)

export const getByDefaultOrderWithTags = async () => {
  const params = {
    query: {
      $modify: 'includeTags,defaultOrder',
    },
  }

  return get(params)
}
